/*
 * Creatorcode-korting (Olfé) — cc-creator-code.js
 *
 * Toont bij elke productprijs de extra korting van een actieve kortingscode
 * (creator-/influencerlink). Bronnen, in volgorde van betrouwbaarheid:
 *   1. De echte winkelwagen (/cart.js): zodra een product in de wagen ligt,
 *      geeft Shopify de exacte korting per regel. Dit wint altijd.
 *   2. Een tijdelijke "proefwagen" via de Storefront API (cartCreate met de
 *      code): Shopify rekent dezelfde kortingsregels door voor de producten
 *      op de pagina, zonder de wagen van de klant aan te raken. Werkt vanaf
 *      het eigen winkeldomein zonder token.
 * Is geen van beide bronnen beschikbaar, dan wordt géén extra prijs getoond.
 * In de winkelwagen (drawer + pagina) worden uitsluitend de echte cijfers van
 * /cart.js gebruikt; de doorgestreepte adviesprijs komt uit /products/<handle>.js.
 * Wepeak (GET /apps/wepeak/discount-info?code=): kent Wepeak de code, dan moet die
 * daar actief zijn en moet het percentage gelijk zijn aan wat Shopify rekent. Kent
 * Wepeak de code niet (bijv. een handmatig aangemaakte Shopify-code) of antwoordt het
 * adres niet, dan geldt Shopify's eigen berekening (stand 'verify'). Stand 'strict'
 * toont dan niets; stand 'off' slaat Wepeak over.
 *
 * Verwijderen: haal `render 'cc-creator-code'` uit layout/theme.liquid.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('cc-creator-code-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var VERSION = '22-09k';
  var CACHE_KEY = 'cc:v1';
  // Klein logboek voor het diagnosepaneel (?cc_debug=1) en de console.
  var LOG = [];
  function dlog(msg) {
    var line = new Date().toTimeString().slice(0, 8) + ' ' + msg;
    LOG.push(line); if (LOG.length > 40) LOG.shift();
    if (debugOn()) { try { console.log('[creatorcode] ' + msg); } catch (e) { /* negeren */ } }
  }
  function debugOn() {
    try {
      if (/[?&]cc_debug=1/.test(location.search)) { sessionStorage.setItem('cc:debug', '1'); return true; }
      if (/[?&]cc_debug=0/.test(location.search)) { sessionStorage.removeItem('cc:debug'); return false; }
      return sessionStorage.getItem('cc:debug') === '1';
    } catch (e) { return /[?&]cc_debug=1/.test(location.search); }
  }
  var COOKIE_NAME = 'discount_code';

  var state = {
    code: null,           // actieve kortingscode
    pct: null,            // percentage als bekend (bijv. 15)
    blocked: false,       // echte winkelwagen mét producten zegt: code niet toepasbaar
    prices: {},           // variantId -> { original, final, pct, source }
    notApplicable: {},    // variantId -> true (code geldt niet voor dit product)
    probing: {},          // variantId -> true (aanvraag loopt)
    orderLevel: false,    // code werkt op bestelniveau (geen regelkorting, wel totaalkorting)
    wepeak: null,         // { status: active|inactive|unknown|error, pct } uit Wepeak, null zolang niet gecontroleerd
    lastCart: null
  };

  /* ---------- hulpfuncties ---------- */

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, cfg.moneyFormat);
      }
    } catch (e) { /* val terug op eigen notatie */ }
    var v = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  }

  function fmtPct(p) {
    if (p == null) return null;
    var r = Math.round(p * 10) / 10;
    if (Math.abs(r - Math.round(r)) < 0.05) return String(Math.round(r));
    return String(r).replace('.', ',');
  }

  function fill(tpl, data) {
    return tpl.replace(/\{(\w+)\}/g, function (m, k) { return data[k] != null ? data[k] : m; });
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function normalize(code) {
    return (code || '').trim().toUpperCase();
  }

  function ignored(code) {
    if (!cfg.ignoreCodes) return false;
    try { return new RegExp(cfg.ignoreCodes, 'i').test(code); } catch (e) { return false; }
  }

  // Vaste regels voor codes die Wepeak niet kent, bijv. de eenmalige Alia-codes (OLFE + 4 tekens = 10%).
  // Ingesteld in de snippet als "regex => percentage", meerdere regels gescheiden door " | ".
  var codeRules = [];
  (cfg.codeRules || '').split(' | ').forEach(function (line) {
    var parts = line.split(' => ');
    if (parts.length !== 2) return;
    try { codeRules.push({ re: new RegExp(parts[0].trim(), 'i'), pct: parseFloat(parts[1]) }); } catch (e) { /* negeren */ }
  });
  function rulePct(code) {
    for (var i = 0; i < codeRules.length; i++) {
      if (code && codeRules[i].re.test(code) && !isNaN(codeRules[i].pct)) return codeRules[i].pct;
    }
    return null;
  }

  function centsFromAmount(a) {
    return Math.round(parseFloat(a) * 100);
  }

  function cacheLoad() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return;
      var c = JSON.parse(raw);
      if (c.code !== state.code || c.country !== cfg.country || c.currency !== cfg.currency) return;
      // Alleen positieve uitkomsten en hooguit 10 minuten oud: een "niet toepasbaar" van
      // eerder mag nooit blijven hangen, anders verdwijnt de derde prijs voor de hele sessie.
      var fresh = c.savedAt && Date.now() - c.savedAt < 10 * 60 * 1000;
      if (fresh) {
        Object.keys(c.prices || {}).forEach(function (k) {
          if (!state.prices[k]) state.prices[k] = c.prices[k];
        });
        if (state.pct == null && c.pct != null) state.pct = c.pct;
      }
      if (c.wepeak && c.wepeakAt && Date.now() - c.wepeakAt < 10 * 60 * 1000) state.wepeak = c.wepeak;
    } catch (e) { /* negeren */ }
  }

  function cacheSave() {
    try {
      var probeOnly = {};
      Object.keys(state.prices).forEach(function (k) {
        if (state.prices[k].source === 'probe') probeOnly[k] = state.prices[k];
      });
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        code: state.code, country: cfg.country, currency: cfg.currency,
        prices: probeOnly, pct: state.pct, savedAt: Date.now(),
        wepeak: state.wepeak, wepeakAt: state.wepeak ? Date.now() : null
      }));
    } catch (e) { /* negeren */ }
  }

  /* ---------- winkelwagen (bron 1: de waarheid) ---------- */

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Code(s) in de wagen zetten. De cart drawer is al door de server gerenderd zonder deze
  // code, dus we laten Shopify de drawer-sectie meteen opnieuw renderen en geven het thema
  // door dat de wagen veranderd is (zelfde weg als het kortingsformulier van het thema).
  function applyCodeToCart(code) {
    var form = document.querySelector('cart-drawer form[is="cart-discount"]');
    var sectionId = form ? form.getAttribute('data-section-id') : null;
    var body = { discount: code };
    if (sectionId) body.sections = [sectionId];
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart && cart.sections && window.theme && theme.pubsub) {
        try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: cart }); } catch (e) { /* negeren */ }
      }
      return cart;
    });
  }

  // Het thema laadt pagina's vooraf (instant-page) en de drawer staat kant-en-klaar in die HTML.
  // Wordt zo'n vooraf geladen pagina later getoond, dan mist de drawer wat intussen is toegevoegd
  // (en telt het icoontje verkeerd). Klopt het aantal regels niet met de echte wagen, dan laten we
  // Shopify de drawer-sectie opnieuw renderen langs dezelfde weg als het thema zelf.
  function drawerSectionId() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var form = drawer.querySelector('form[is="cart-discount"]');
    return form ? form.getAttribute('data-section-id') : (drawer.getAttribute('data-section-id') || null);
  }

  // De drawer-sectie door Shopify opnieuw laten renderen op basis van de echte wagen.
  function rerenderDrawer() {
    var sectionId = drawerSectionId();
    if (!sectionId) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: [sectionId] })
    }).then(function (r) { return r.json(); }).then(function (fresh) {
      if (fresh && fresh.sections && window.theme && theme.pubsub) {
        try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: fresh }); } catch (e) { /* negeren */ }
      }
    }).catch(function () {});
  }

  var drawerChecked = false;
  function syncDrawer(cart) {
    if (drawerChecked || !cart) return;
    drawerChecked = true;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var shown = drawer.querySelectorAll('[id^="CartDrawer-Item-"]').length;
    var expected = (cart.items || []).length;
    if (shown === expected) return;
    rerenderDrawer();
  }

  // Verwijderen/aantal wijzigen in de drawer: het thema stuurt de regel-key uit de HTML naar
  // Shopify. Is de drawer verouderd (regel bestaat niet meer, of onder een andere key), dan
  // antwoordt Shopify "geen geldige ID of regelnummer" en springt het thema naar /cart. Daarom
  // eerst de echte wagen raadplegen: bestaat de key, gewoon doorgaan; hoort de variant bij een
  // andere key, die gebruiken; is de regel weg, dan de drawer stil opnieuw renderen.
  function guardCartItems() {
    if (typeof customElements === 'undefined' || !customElements.whenDefined) return;
    customElements.whenDefined('cart-items').then(function () {
      var CI = customElements.get('cart-items');
      if (!CI || !CI.prototype || CI.prototype.__ccGuarded) return;
      CI.prototype.__ccGuarded = true;
      var orig = CI.prototype.updateQuantity;
      CI.prototype.updateQuantity = function (line, quantity, name, target) {
        var self = this, args = arguments;
        if (!/^\d+:[a-f0-9]{32}$/.test(String(line))) return orig.apply(self, args);
        return fetchCart().then(function (cart) {
          var items = cart.items || [];
          if (items.some(function (i) { return i.key === line; })) return orig.apply(self, args);
          var vid = String(line).split(':')[0];
          var alt = items.filter(function (i) { return String(i.variant_id) === vid; })[0];
          if (alt) {
            console.warn('[creatorcode] regel-key verouderd, herstel naar', alt.key);
            return orig.call(self, alt.key, quantity, name, target);
          }
          console.warn('[creatorcode] regel bestaat niet meer, drawer opnieuw renderen');
          if (typeof self.disableLoading === 'function') { try { self.disableLoading(line); } catch (e) { /* negeren */ } }
          return rerenderDrawer();
        }).catch(function () { return orig.apply(self, args); });
      };
    }).catch(function () {});
  }

  function ingestCart(cart) {
    if (!cart || !cart.discount_codes) { dlog('ingestCart: wagen zonder discount_codes genegeerd'); return; }
    state.lastCart = cart;
    dlog('ingestCart: ' + (cart.items || []).length + ' regels, codes=' + JSON.stringify(cart.discount_codes) + ', korting=' + cart.total_discount);
    syncDrawer(cart);

    var codes = cart.discount_codes.filter(function (d) { return d && d.code && !ignored(d.code); });
    var entry = codes.filter(function (d) { return d.applicable; })[0] || codes[0] || null;
    var newCode = entry ? normalize(entry.code) : null;

    if (newCode !== state.code) {
      state.code = newCode;
      state.pct = null;
      state.prices = {};
      state.notApplicable = {};
      state.blocked = false;
      state.wepeak = null;
      if (newCode) cacheLoad();
    }
    if (!state.code) { render(); return; }
    if (cfg.wepeakMode !== 'off' && !state.wepeak) verifyWepeak(state.code);

    // Elke wagenwijziging: "niet toepasbaar"-uitkomsten vergeten en opnieuw doorrekenen.
    state.notApplicable = {};

    var hasItems = (cart.item_count || 0) > 0;
    state.blocked = !!(hasItems && entry && entry.applicable === false);

    // Exacte regels uit de echte winkelwagen.
    var anyLineAlloc = false;
    (cart.items || []).forEach(function (item) {
      var codeAmount = 0, otherAmount = 0, pct = null;
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (app.type === 'discount_code' && normalize(app.title) === state.code) {
          codeAmount += a.amount;
          if (app.value_type === 'percentage') pct = parseFloat(app.value);
        } else {
          otherAmount += a.amount;
        }
      });
      if (codeAmount > 0) {
        anyLineAlloc = true;
        state.prices[item.variant_id] = {
          original: item.original_price, final: item.final_price, pct: pct, source: 'cart'
        };
        delete state.notApplicable[item.variant_id];
        if (pct != null) state.pct = pct;
      }
    });
    state.orderLevel = !!(hasItems && entry && entry.applicable && !anyLineAlloc && (cart.total_discount || 0) > 0);
    if (state.orderLevel && state.pct == null) {
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        if (d.type === 'discount_code' && normalize(d.title) === state.code && d.value_type === 'percentage') state.pct = parseFloat(d.value);
      });
    }
    // Code is toepasbaar op productniveau, maar niet voor deze regels: dan ook niet tonen.
    if (anyLineAlloc) {
      (cart.items || []).forEach(function (item) {
        if (!state.prices[item.variant_id] || state.prices[item.variant_id].source !== 'cart') {
          delete state.prices[item.variant_id];
          state.notApplicable[item.variant_id] = true;
        }
      });
    }
    render();
    scan();
  }

  /* ---------- Wepeak: is de code actief en welk percentage hoort erbij ---------- */

  var wepeakPending = {};
  function verifyWepeak(code) {
    if (wepeakPending[code]) return wepeakPending[code];
    var url = cfg.wepeakEndpoint + (cfg.wepeakEndpoint.indexOf('?') === -1 ? '?' : '&') + 'code=' + encodeURIComponent(code);
    var wpTimer = null;
    var wpTimeout = new Promise(function (resolve) { wpTimer = setTimeout(function () { dlog('wepeak: geen antwoord binnen 3 s'); resolve({ status: 'error', pct: null }); }, 3000); });
    var wpReq = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) return { status: 'unknown', pct: null };
        if (!r.ok) return { status: 'error', pct: null };
        return r.json().then(function (data) {
          if (!data || typeof data !== 'object') return { status: 'error', pct: null };
          var d = data.discount && typeof data.discount === 'object' ? data.discount : data;
          if (d.error) return { status: 'unknown', pct: null };
          var active = d.active;
          if (active == null) active = d.is_active;
          if (active == null && typeof d.status === 'string') active = d.status.toLowerCase() === 'active';
          var pct = d.percentage;
          if (pct == null) pct = d.percent;
          if (pct == null) pct = d.discount_percentage;
          if (pct == null) pct = d.wp_discount;
          pct = pct == null ? null : parseFloat(pct);
          var returnedCode = normalize(d.code || data.code || code);
          if (returnedCode !== code) return { status: 'unknown', pct: null };
          if (active !== true) return { status: 'inactive', pct: null };
          return { status: pct != null && !isNaN(pct) ? 'active' : 'inactive', pct: pct };
        });
      })
      .catch(function () { return { status: 'error', pct: null }; });
    wepeakPending[code] = Promise.race([wpReq, wpTimeout])
      .then(function (result) {
        clearTimeout(wpTimer);
        dlog('wepeak ' + code + ': ' + result.status + (result.pct != null ? ' ' + result.pct + '%' : ''));
        if (code === state.code) { state.wepeak = result; cacheSave(); }
        delete wepeakPending[code];
        render();
        scan();
        return result;
      });
    return wepeakPending[code];
  }

  // Is de code al door Shopify zelf bevestigd (korting in de echte wagen)?
  function shopifyConfirmed() {
    if (state.orderLevel) return true;
    for (var k in state.prices) if (state.prices[k] && state.prices[k].source === 'cart') return true;
    return false;
  }
  function allowed() {
    if (!state.code || state.blocked) return false;
    if (cfg.wepeakMode === 'off') return true;
    // Wepeak is een extra check, nooit een poortwachter: een code die op een vaste regel past
    // (Alia) of die Shopify al in de wagen doorrekent, tonen we meteen, ook als Wepeak nog
    // niet (of niet) geantwoord heeft.
    if (!state.wepeak) return rulePct(state.code) != null || shopifyConfirmed();
    if (state.wepeak.status === 'active') return true;
    if (state.wepeak.status === 'inactive') return false;
    return cfg.wepeakMode === 'verify';                  // unknown/error: alleen in stand 'verify' terugvallen op Shopify
  }

  // Klopt het percentage van deze prijs met wat Wepeak zegt (als Wepeak de code kent)?
  function pctMatches(pct) {
    if (!state.wepeak || state.wepeak.status !== 'active') return true;
    if (pct == null) return false;
    return Math.abs(parseFloat(pct) - state.wepeak.pct) < 0.05;
  }

  /* ---------- proefwagen (bron 2: Storefront API) ---------- */

  var Q_FULL = 'mutation cc($lines:[CartLineInput!]!,$codes:[String!],$country:CountryCode)@inContext(country:$country){' +
    'cartCreate(input:{lines:$lines,discountCodes:$codes,buyerIdentity:{countryCode:$country}}){' +
    'cart{discountCodes{code applicable}lines(first:250){nodes{quantity merchandise{... on ProductVariant{id}}' +
    'cost{subtotalAmount{amount currencyCode}}' +
    'discountAllocations(lineLevelOnly:false){discountedAmount{amount}' +
    '... on CartCodeDiscountAllocation{code sourceDiscountApplication{value{__typename ... on PricingPercentageValue{percentage}}}}}}}}' +
    'userErrors{message}}}';

  var Q_BASIC = 'mutation cc($lines:[CartLineInput!]!,$codes:[String!],$country:CountryCode)@inContext(country:$country){' +
    'cartCreate(input:{lines:$lines,discountCodes:$codes,buyerIdentity:{countryCode:$country}}){' +
    'cart{discountCodes{code applicable}lines(first:250){nodes{quantity merchandise{... on ProductVariant{id}}' +
    'cost{subtotalAmount{amount currencyCode}}' +
    'discountAllocations{discountedAmount{amount}... on CartCodeDiscountAllocation{code}}}}}' +
    'userErrors{message}}}';

  function storefront(query, variables) {
    var url = location.origin + '/api/' + cfg.apiVersion + '/graphql.json';
    var headers = { 'Content-Type': 'application/json' };
    if (cfg.token) headers['X-Shopify-Storefront-Access-Token'] = cfg.token;
    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  function probe(variantIds) {
    if (!state.code || !variantIds.length) return Promise.resolve();
    var code = state.code;
    variantIds.forEach(function (id) { state.probing[id] = true; });
    var vars = {
      lines: variantIds.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; }),
      codes: [code],
      country: cfg.country || null
    };
    return storefront(Q_FULL, vars).then(function (res) {
      if (res && res.errors && res.errors.length) return storefront(Q_BASIC, vars);
      return res;
    }).then(function (res) {
      if (code !== state.code) return;
      var cart = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
      if (!cart) {
        console.warn('[creatorcode] proefwagen mislukt', res && (res.errors || res.data));
        // Zonder token beperkt Shopify de Storefront API streng ("Throttled"). Is het
        // percentage al bekend uit de echte wagen, dan rekenen we daarmee; anders later
        // opnieuw proberen, steeds met een langere pauze.
        var pctKnown = state.pct != null ? state.pct : null;
        if (pctKnown != null) {
          variantIds.forEach(function (id) { if (!state.prices[id] && probePrices[id]) estimate(id, probePrices[id], pctKnown, 'estimate'); });
        } else {
          probeFailures += 1;
          setTimeout(scan, Math.min(3000 * Math.pow(2, probeFailures - 1), 60000));
        }
        return;
      }
      probeFailures = 0;
      var entry = (cart.discountCodes || []).filter(function (d) { return normalize(d.code) === code; })[0];
      var applicable = !!(entry && entry.applicable);
      var seen = {};
      (cart.lines.nodes || []).forEach(function (line) {
        var gid = line.merchandise && line.merchandise.id || '';
        var vid = gid.split('/').pop();
        if (!vid) return;
        seen[vid] = true;
        var sub = line.cost && line.cost.subtotalAmount;
        if (!sub || (cfg.currency && sub.currencyCode !== cfg.currency) || line.quantity !== 1) { return; }
        var subCents = centsFromAmount(sub.amount);
        var codeAmount = 0, otherAmount = 0, pct = null;
        (line.discountAllocations || []).forEach(function (a) {
          var amt = centsFromAmount(a.discountedAmount.amount);
          if (a.code && normalize(a.code) === code) {
            codeAmount += amt;
            var v = a.sourceDiscountApplication && a.sourceDiscountApplication.value;
            if (v && v.__typename === 'PricingPercentageValue') pct = parseFloat(v.percentage);
          } else {
            otherAmount += amt;
          }
        });
        if (state.prices[vid] && state.prices[vid].source === 'cart') return; // echte wagen wint
        if (applicable && codeAmount > 0 && otherAmount === 0) {
          if (pct == null) pct = Math.round((codeAmount / subCents) * 1000) / 10;
          state.prices[vid] = { original: subCents, final: subCents - codeAmount, pct: pct, source: 'probe' };
          delete state.notApplicable[vid];
          if (state.pct == null) state.pct = pct;
        } else if (state.orderLevel && state.pct != null && otherAmount === 0 && (!applicable || codeAmount === 0)) {
          // Code werkt in de echte wagen op bestelniveau (bijv. met minimumbedrag): een losse
          // proefwagen haalt dat minimum niet, maar de klant krijgt de korting wel zodra het
          // product in de wagen ligt. Reken dan met het percentage uit de echte wagen.
          state.prices[vid] = { original: subCents, final: Math.round(subCents * (100 - state.pct) / 100), pct: state.pct, source: 'order' };
          delete state.notApplicable[vid];
        } else {
          state.notApplicable[vid] = true;
        }
      });
      // Regels die Shopify wegliet (bijv. uitverkocht): geen prijs tonen.
      variantIds.forEach(function (id) { if (!seen[id] && !state.prices[id]) state.notApplicable[id] = true; });
      cacheSave();
    }).catch(function (err) {
      console.warn('[creatorcode] proefwagen fout', err);
    }).then(function () {
      variantIds.forEach(function (id) { delete state.probing[id]; });
      render();
    });
  }

  /* ---------- DOM ---------- */

  function priceElements() {
    var all = document.querySelectorAll('.price[data-cc-variant], .cart-rec-card__price[data-cc-variant]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('.cc-cart-price')) out.push(all[i]);
    }
    return out;
  }

  // "Vaak samen gekocht" (bundle-save): de prijs per kaart, met variant-id uit bundle-save.js
  function bundlePriceElements() {
    return document.querySelectorAll('bundle-save [data-card-price][data-cc-variant]');
  }

  // Prijs met code lokaal uitrekenen (zelfde afronding als Shopify: halve centen omhoog).
  var probePrices = {};      // variantId -> prijs op de pagina (voor de terugval bij een mislukte proefwagen)
  var probeFailures = 0;
  function estimate(vid, price, pct, source) {
    if (!price || pct == null) return;
    state.prices[vid] = { original: price, final: Math.round(price * (100 - pct) / 100), pct: pct, source: source };
    delete state.notApplicable[vid];
  }

  // Productpagina: alle varianten van dit product vooraf doorrekenen, zodat een maat- of
  // kleurwissel de prijs met code meteen kan tonen (het thema vervangt dan het prijsblok en
  // wij zetten in dezelfde stap de derde prijs terug, zonder te hoeven wachten).
  var pdpVariants = null;
  function preloadPdpVariants() {
    if (pdpVariants) return;
    pdpVariants = {};
    var pi = document.querySelector('product-info[data-product-url]');
    var m = pi ? (pi.getAttribute('data-product-url') || '').match(/\/products\/([^/?#]+)/) : null;
    if (!m) return;
    productJson(m[1]).then(function (p) {
      if (!p || !p.variants) return;
      p.variants.forEach(function (v) { if (v && v.id && v.price) pdpVariants[v.id] = v.price; });
      scan();
    });
  }

  // Direct (zonder wachttijd) tekenen en ontbrekende prijzen ophalen/berekenen.
  function scanNow() {
    render();
    if (!allowed()) return;
    var need = {};
    var bundleIds = {};   // sets: alleen de echte proefwagen weet of de code geldt (VIP15 wel, influencercodes niet)
    var collect = function (el) {
      var vid = el.getAttribute('data-cc-variant');
      if (!vid || state.prices[vid] || state.notApplicable[vid] || state.probing[vid]) return;
      if (el.getAttribute('data-cc-bundle') === 'true') bundleIds[vid] = true;
      need[vid] = parseInt(el.getAttribute('data-cc-price'), 10) || 0;
      probePrices[vid] = need[vid];
    };
    priceElements().forEach(collect);
    Array.prototype.forEach.call(bundlePriceElements(), collect);
    // Bundelpagina: alleen de gekozen combinatie doorrekenen (de bundelkiezer zet die op de prijs);
    // 125 bundelvarianten in één proefwagen weigert Shopify.
    if (pdpVariants && !document.querySelector('[data-obp]')) {
      Object.keys(pdpVariants).forEach(function (vid) {
        if (state.prices[vid] || state.notApplicable[vid] || state.probing[vid] || need[vid]) return;
        need[vid] = pdpVariants[vid];
        probePrices[vid] = need[vid];
      });
    }
    var ids = Object.keys(need);
    if (!ids.length) return;
    // Wepeak kent de code en het percentage (bron van waarheid): dan rekenen we lokaal en is
    // er geen proefwagen nodig. Dat scheelt Storefront-aanroepen (die zonder token snel
    // "Throttled" raken) en werkt daardoor altijd, ook meteen na het invoeren van een code.
    var known = null, source = null;
    if (state.wepeak && state.wepeak.status === 'active' && state.wepeak.pct != null) { known = state.wepeak.pct; source = 'wepeak'; }
    else if (rulePct(state.code) != null) { known = rulePct(state.code); source = 'rule'; }
    else if (state.pct != null && !cfg.token) { known = state.pct; source = 'estimate'; }   // uit de echte wagen; zonder token is een proefwagen kansloos
    if (known != null) {
      var toProbe = ids.filter(function (id) { return bundleIds[id]; });
      ids.forEach(function (id) { if (!bundleIds[id]) estimate(id, need[id], known, source); });
      render();
      if (toProbe.length && cfg.token) { for (var t = 0; t < toProbe.length; t += 10) probe(toProbe.slice(t, t + 10)); }
      return;
    }
    var plain = ids.filter(function (id) { return !bundleIds[id]; });
    var sets = ids.filter(function (id) { return bundleIds[id]; });
    for (var i = 0; i < plain.length; i += 100) probe(plain.slice(i, i + 100));
    for (var k = 0; k < sets.length; k += 10) probe(sets.slice(k, k + 10));
  }

  var scanTimer = null;
  function scan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scanNow, 60);
  }

  function strip(el) {
    el.classList.remove('cc-active');
    el.classList.remove('cc-has-badge');
    var nodes = el.querySelectorAll('.cc-node');
    for (var i = 0; i < nodes.length; i++) nodes[i].parentNode.removeChild(nodes[i]);
    el.removeAttribute('data-cc-sig');
  }

  function mk(cls, html) {
    var s = document.createElement('span');
    s.className = cls + ' cc-node';
    s.innerHTML = html;
    return s;
  }

  function renderOne(el) {
    var vid = el.getAttribute('data-cc-variant');
    var price = parseInt(el.getAttribute('data-cc-price'), 10);
    var compare = parseInt(el.getAttribute('data-cc-compare') || '0', 10);
    var varies = el.getAttribute('data-cc-varies') === 'true';
    var onSale = compare > price;
    var salePct = onSale ? Math.round((compare - price) * 100 / compare) : 0;

    var info = allowed() ? state.prices[vid] : null;
    // Veiligheid: de doorgerekende basisprijs moet gelijk zijn aan wat de pagina toont,
    // en het percentage moet overeenkomen met wat Wepeak voor deze code opgeeft.
    if (info && info.original !== price) info = null;
    if (info && !pctMatches(info.pct)) info = null;

    if (info) el.setAttribute('data-cc-final', info.final); else el.removeAttribute('data-cc-final');

    var sig = info ? [state.code, info.final, info.pct].join(':') : (cfg.showSaleBadgeAlways && onSale ? 'sale:' + salePct : '');
    if (el.getAttribute('data-cc-sig') === sig) return;
    strip(el);
    if (!sig) return;
    el.setAttribute('data-cc-sig', sig);

    if (onSale) {
      el.classList.add('cc-has-badge');
      el.appendChild(mk('cc-sale-badge badge badge--onsale', '-' + salePct + '%'));
    }
    if (!info) return;

    el.classList.add('cc-active');
    el.appendChild(mk('cc-break', ''));
    var finalHtml = money(info.final);
    if (varies) finalHtml = '<small>' + (cfg.strings.from || 'Vanaf') + '</small> ' + finalHtml;
    el.appendChild(mk('cc-final', finalHtml));
    var label = info.pct != null ? '-' + fmtPct(info.pct) + '%' : '-' + money(info.original - info.final);
    var badge = mk('cc-code-badge badge badge--onsale', label);
    badge.setAttribute('title', fill(cfg.strings.badgeTitle, { code: state.code }));
    el.appendChild(badge);
  }

  /* ---------- "Vaak samen gekocht" (bundle-save op de productpagina) ----------
     Per kaart dezelfde derde prijs als elders: actieprijs doorgestreept, prijs met code in rood
     plus -X%-badge. Onder het blok een derde totaal (alleen als elke meegetelde kaart een
     codeprijs heeft), zodat kaarten en totaal bij elkaar blijven passen. */

  function renderBundleTotals() {
    var roots = document.querySelectorAll('bundle-save');
    Array.prototype.forEach.call(roots, function (root) {
      var totalEl = root.querySelector('[data-bundle-total]');
      var row = totalEl ? totalEl.parentNode : null;
      if (!row) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var anyComplete = cards.some(function (c) { var st = c.querySelector('[data-card-status]'); return st && st.classList.contains('is-selected'); });
      // Zonder gekozen maat geen totaal (het thema verbergt de regel dan ook).
      var included = cards.filter(function (c) {
        if (!anyComplete) return false;
        var st = c.querySelector('[data-card-status]');
        return st && st.classList.contains('is-selected');
      });
      // Totaalregel van het thema pas tonen zodra er een maat gekozen is (anders lijkt het
      // alsof je beide producten moet afnemen).
      if (row.hidden !== !anyComplete) row.hidden = !anyComplete;
      var sum = 0, complete = included.length > 0;
      included.forEach(function (c) {
        var p = c.querySelector('[data-card-price]');
        var f = p ? p.getAttribute('data-cc-final') : null;
        if (f == null) complete = false; else sum += parseInt(f, 10);
      });
      var existing = row.querySelector('.cc-bundle-total');
      var sig = complete && allowed() ? state.code + ':' + sum : '';
      // Knop "Artikel toevoegen · €49,95": het bedrag achter het puntje meenemen naar de codeprijs.
      // (bundle-save.js zet die tekst bij elke wijziging opnieuw; wij lopen daar steeds achteraan.)
      var submitText = root.querySelector('[data-bundle-submit-text]');
      if (submitText && submitText.textContent.indexOf('·') !== -1) {
        var parts = submitText.textContent.split('·');
        var want = sig && anyComplete ? parts[0] + '· ' + money(sum).replace(/<[^>]+>/g, '') : null;
        if (want && submitText.textContent !== want) submitText.textContent = want;
      }
      // "Bespaar ..."-badge van het thema: met code het totale voordeel (advies- of actieprijs
      // min de prijs met code); zonder code weer de eigen tekst van het thema.
      var badgeEl = root.querySelector('[data-bundle-badge]');
      if (badgeEl) {
        if (sig) {
          var compareEl = root.querySelector('[data-bundle-compare]');
          var base = compareEl && !compareEl.hidden ? parseInt(compareEl.getAttribute('data-cc-cents') || '0', 10) : 0;
          if (!base) base = typeof root.bundleTotal === 'number' ? root.bundleTotal : 0;
          if (compareEl && !compareEl.hidden && typeof root.bundleSavings === 'number' && typeof root.bundleTotal === 'number') base = root.bundleTotal + root.bundleSavings;
          var saveText = (root.getAttribute('data-save-label') || 'Bespaar') + ' ' + money(base - sum).replace(/<[^>]+>/g, '');
          if (base > sum && badgeEl.textContent !== saveText) {
            if (!badgeEl.hasAttribute('data-cc-orig')) badgeEl.setAttribute('data-cc-orig', badgeEl.textContent);
            badgeEl.textContent = saveText;
            badgeEl.hidden = false;
          }
        } else if (badgeEl.hasAttribute('data-cc-orig')) {
          badgeEl.textContent = badgeEl.getAttribute('data-cc-orig');
          badgeEl.removeAttribute('data-cc-orig');
          if (!badgeEl.textContent) badgeEl.hidden = true;
        }
      }
      if (existing && existing.getAttribute('data-cc-sig') === sig) return;
      if (existing) existing.parentNode.removeChild(existing);
      var oldBreak = row.querySelector('.cc-bundle-break');
      if (oldBreak) oldBreak.parentNode.removeChild(oldBreak);
      row.classList.toggle('cc-active', !!sig);
      if (!sig) return;
      var span = mk('cc-final cc-bundle-total', money(sum));
      span.setAttribute('data-cc-sig', sig);
      span.setAttribute('title', fill(cfg.strings.codeTitle, { code: state.code }));
      totalEl.parentNode.insertBefore(mk('cc-break cc-bundle-break', ''), totalEl.nextSibling);
      totalEl.parentNode.insertBefore(span, totalEl.nextSibling.nextSibling);
    });
  }

  /* ---------- winkelwagen-regels (drawer + pagina) ---------- */

  // Product-JSON (/products/<handle>.js) voor de adviesprijs. Een mislukte of hangende aanvraag
  // (max. 6 s) levert null op en wordt niet onthouden, zodat een volgende poging opnieuw probeert;
  // anders zou één hangende aanvraag alle regels van dat product voorgoed leeg laten.
  var productCache = {};
  var productData = {};      // handle -> JSON zodra binnen (synchroon te gebruiken)
  function productJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (productData[handle]) return Promise.resolve(productData[handle]);
    if (!productCache[handle]) {
      var timer = null;
      var timeout = new Promise(function (resolve) { timer = setTimeout(function () { resolve(null); }, 6000); });
      var req = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      productCache[handle] = Promise.race([req, timeout]).then(function (p) {
        clearTimeout(timer);
        if (p && p.variants) productData[handle] = p; else delete productCache[handle];
        return p || null;
      });
    }
    return productCache[handle];
  }

  // Adviesprijs uit de HTML van de wagenregel (het thema zet die doorgestreept in .price),
  // zodat de regel meteen synchroon getekend kan worden zonder op product-JSON te wachten.
  function parseMoney(text) {
    var t = (text || '').replace(/[^\d.,]/g, '');
    if (!t) return 0;
    var hasDec = /[.,]\d{1,2}$/.test(t);
    var digits = t.replace(/[.,]/g, '');
    var n = parseInt(digits, 10);
    if (isNaN(n)) return 0;
    if (!hasDec) return n * 100;
    if (/[.,]\d$/.test(t)) return n * 10;
    return n;
  }
  function domCompare(el, item) {
    var s = el.querySelector('.price span[style*="line-through"]');
    if (!s) return 0;
    var c = parseMoney(s.textContent);
    return c > item.original_price ? c : 0;
  }
  function jsonCompare(p, item) {
    if (!p || !p.variants) return 0;
    var v = p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
    return v && v.compare_at_price ? v.compare_at_price : 0;
  }

  function cartLineElements() {
    return document.querySelectorAll('[id^="CartDrawer-Item-"], tr[id^="CartItem-"]');
  }

  function paintCartLine(el, item, compare) {
    var priceEl = el.querySelector('.price');
    var existing = el.querySelector('.cc-cart-price');
    if (!priceEl) return;

    var codeAmount = 0, otherAmount = 0, pct = null, others = [];
    (item.line_level_discount_allocations || []).forEach(function (a) {
      var app = a.discount_application || {};
      if (app.type === 'discount_code' && normalize(app.title) === state.code) {
        codeAmount += a.amount;
        if (app.value_type === 'percentage') pct = parseFloat(app.value);
      } else {
        otherAmount += a.amount;
        others.push({ title: app.title || '', amount: a.amount });
      }
    });

    // In de drawer tonen we regelbedragen (prijs x aantal), zodat alle drie de prijzen meegroeien
    // met het aantal, net als het subtotaal. Op de winkelwagenpagina blijft de stuksprijs in de
    // artikelkolom staan; daar heeft het thema een aparte totaalkolom (die we ook bijwerken).
    var qty = item.quantity || 1;
    var inDrawer = /^CartDrawer-Item-/.test(el.id || '');
    var unitOriginal = item.original_price;
    var unitFinal = item.final_price;
    var lineOriginal = item.original_line_price != null ? item.original_line_price : unitOriginal * qty;
    var lineFinal = item.final_line_price != null ? item.final_line_price : unitFinal * qty;
    var mode = null;
    if (!allowed()) { codeAmount = 0; }
    if (codeAmount > 0) {
      mode = 'line';
    } else if (state.orderLevel && unitOriginal === unitFinal && state.pct != null) {
      // Code op bestelniveau: Shopify verdeelt de totale korting naar rato over de regels.
      // Dat rekenen we na, zodat de regelprijs optelt tot het subtotaal van Shopify.
      mode = 'order';
      pct = state.pct;
      var cart = state.lastCart || {};
      var subtotal = cart.items_subtotal_price || 0;
      var share = subtotal > 0 ? Math.round((cart.total_discount || 0) * lineOriginal / subtotal) : 0;
      lineFinal = share > 0 ? lineOriginal - share : Math.round(lineOriginal * (100 - pct) / 100);
      unitFinal = Math.round(lineFinal / qty);
    }
    if (mode && !pctMatches(pct)) mode = null;
    // Geen (geldige) code, wel een doorgestreepte adviesprijs: zelfde opmaak als met code
    // (adviesprijs doorgestreept, sale-badge, actieprijs in rood), zonder codebadge.
    if (!mode && codeAmount === 0 && otherAmount === 0 && compare > unitOriginal && unitOriginal === unitFinal) mode = 'sale';
    paintCartTotalCell(el, item, mode, lineOriginal, lineFinal, compare * qty);
    if (!mode) { if (existing) existing.parentNode.removeChild(existing); return; }
    if (inDrawer) {
      compare = compare * qty;
      unitOriginal = lineOriginal;
      unitFinal = lineFinal;
    }

    var sig = [state.code, mode, unitOriginal, unitFinal, pct, compare, inDrawer ? qty : 1].join(':');
    if (existing && existing.getAttribute('data-cc-sig') === sig) return;
    if (existing) existing.parentNode.removeChild(existing);

    var onSale = compare > unitOriginal;
    // Twee vaste regels die elk in één stuk blijven (niet halverwege afbreken), zodat de
    // bolletjes op elke schermbreedte op dezelfde plek staan:
    //   regel 1: adviesprijs, actieprijs (doorgestreept), -X%-bolletje
    //   regel 2: prijs met code, -Y%-bolletje, code-bolletje
    var html = '';
    var salePct = onSale ? Math.round((compare - unitOriginal) * 100 / compare) : 0;
    if (mode === 'sale') {
      // Alleen adviesprijs doorgestreept + actieprijs + badge erachter (zelfde volgorde als met code).
      html = '<span class="cc-row"><span class="cc-strike">' + money(compare) + '</span>' +
        '<span class="cc-final">' + money(unitOriginal) + '</span>' +
        '<span class="cc-badge badge badge--onsale">-' + salePct + '%</span></span>';
    } else {
      html = '<span class="cc-row">';
      if (onSale) html += '<span class="cc-strike">' + money(compare) + '</span>';
      html += '<span class="cc-strike">' + money(unitOriginal) + '</span>';
      if (onSale) html += '<span class="cc-badge badge badge--onsale">-' + salePct + '%</span>';
      html += '</span><span class="cc-break"></span><span class="cc-row">';
      html += '<span class="cc-final">' + money(unitFinal) + '</span>';
      var label = pct != null ? '-' + fmtPct(pct) + '%' : '-' + money(unitOriginal - unitFinal);
      html += '<span class="cc-badge badge badge--onsale" title="' + fill(cfg.strings.badgeTitle, { code: state.code }) + '">' + label + '</span>';
      html += '<span class="cc-badge cc-code badge badge--onsale" title="' + fill(cfg.strings.codeTitle, { code: state.code }) + '">' + state.code + '</span>';
      html += '</span>';
    }
    others.forEach(function (o) {
      html += '<span class="cc-other">' + o.title + ': -' + money(o.amount) + '</span>';
    });

    var div = document.createElement('div');
    div.className = 'cc-cart-price text-sm flex flex-wrap';
    div.setAttribute('data-cc-sig', sig);
    div.setAttribute('data-cc-mode', mode);
    div.innerHTML = html;
    priceEl.parentNode.insertBefore(div, priceEl);
    fitCartLine(div);
  }

  // Past een rij niet in de kolom (groot aantal, lange code, smalle telefoon), dan eerst alleen het
  // code-bolletje weglaten (de code staat ook in het kortingsveld); helpt dat niet, dan mag de
  // rij alsnog afbreken. Zo wordt de aantal-kolom nooit weggedrukt.
  function fitCartLine(div) {
    div.classList.remove('cc-tight');
    div.classList.remove('cc-wrap');
    var rows = div.querySelectorAll('.cc-row');
    if (!rows.length || !div.clientWidth) return;
    var fits = function () {
      for (var i = 0; i < rows.length; i++) if (rows[i].scrollWidth > rows[i].clientWidth + 1) return false;
      return true;
    };
    if (fits()) return;
    div.classList.add('cc-tight');
    if (fits()) return;
    div.classList.remove('cc-tight');
    div.classList.add('cc-wrap');
  }

  function refitCartLines() {
    var divs = document.querySelectorAll('.cc-cart-price');
    for (var i = 0; i < divs.length; i++) fitCartLine(divs[i]);
  }

  // Winkelwagenpagina: de totaalkolom van het thema toont het regelbedrag zonder de korting op
  // bestelniveau. Met code zetten we daar het regelbedrag met code (en het oude bedrag erboven).
  function paintCartTotalCell(el, item, mode, lineOriginal, lineFinal, compareLine) {
    if (!/^CartItem-/.test(el.id || '')) return;
    var cell = el.querySelector('td:last-child .price, .cart-item__totals .price, .price.text-base-xl');
    if (!cell) return;
    var wantCode = (mode === 'line' || mode === 'order') && lineFinal < lineOriginal;
    if (!wantCode) {
      if (cell.hasAttribute('data-cc-orig')) { cell.innerHTML = cell.getAttribute('data-cc-orig'); cell.removeAttribute('data-cc-orig'); cell.classList.remove('cc-total-active'); }
      return;
    }
    var sig = [state.code, lineOriginal, lineFinal].join(':');
    if (cell.getAttribute('data-cc-total-sig') === sig) return;
    if (!cell.hasAttribute('data-cc-orig')) cell.setAttribute('data-cc-orig', cell.innerHTML);
    cell.setAttribute('data-cc-total-sig', sig);
    cell.classList.add('cc-total-active');
    cell.innerHTML = '<span class="cc-strike">' + money(lineOriginal) + '</span><span class="cc-final">' + money(lineFinal) + '</span>';
  }

  // Welke wagenregel hoort bij dit element? Eerst op regel-key (id), anders op variant + aantal,
  // anders alleen variant. Zo wordt er ook getekend als de HTML en /cart.js een andere key voeren.
  var keyMismatch = false;   // gezet zodra een regel alleen via de terugval gevonden is
  function findCartItem(el, items) {
    var key = el.id.replace(/^CartDrawer-Item-|^CartItem-/, '');
    var i, it;
    for (i = 0; i < items.length; i++) if (items[i].key === key) return items[i];
    var vid = el.getAttribute('data-variant-id');
    var qty = parseInt(el.getAttribute('data-quantity') || '0', 10);
    if (!vid) return null;
    for (i = 0; i < items.length; i++) { it = items[i]; if (String(it.variant_id) === vid && it.quantity === qty) { keyMismatch = true; return it; } }
    for (i = 0; i < items.length; i++) { it = items[i]; if (String(it.variant_id) === vid) { keyMismatch = true; return it; } }
    return null;
  }

  // De drawer-HTML die Shopify bij /cart/add.js meestuurt kan andere regel-keys bevatten dan
  // /cart.js daarna (gezien na toevoegen via de aanbevelingskaart met een code in de wagen).
  // Onze regels tekenen dan via de terugval; daarnaast laten we de drawer-sectie eenmalig stil
  // opnieuw renderen, zodat ook verwijderen/aantal van het thema weer de juiste key sturen.
  var lastRerender = 0;
  function healDrawerKeys() {
    if (!keyMismatch) return;
    keyMismatch = false;
    var now = Date.now();
    if (now - lastRerender < 5000) return;
    lastRerender = now;
    dlog('regel-keys wijken af van /cart.js: drawer opnieuw renderen');
    rerenderDrawer();
  }

  var renderCartCount = 0;
  function renderCart() {
    var els = cartLineElements();
    if (!els.length) return;
    renderCartCount++;
    var items = (state.lastCart && state.lastCart.items) || [];
    Array.prototype.forEach.call(els, function (el) {
      var item = findCartItem(el, items);
      var existing = el.querySelector('.cc-cart-price');
      if (!item) {
        dlog('geen wagenregel voor ' + el.id.slice(-12) + ' (lastCart ' + items.length + ' regels)');
        return;
      }
      if (!allowed() && existing && existing.getAttribute('data-cc-mode') !== 'sale') {
        existing.parentNode.removeChild(existing);
      }
      // Meteen tekenen: adviesprijs uit de HTML (drawer) of uit al bekende product-JSON.
      var handle = el.getAttribute('data-handle') || item.handle;
      var compare = domCompare(el, item) || jsonCompare(productData[handle], item);
      try { paintCartLine(el, item, compare); } catch (e) { dlog('FOUT wagenregel: ' + (e && e.message)); console.warn('[creatorcode] wagenregel', e); }
      // Winkelwagenpagina toont geen adviesprijs in de HTML: die komt na uit de product-JSON.
      if (!compare && !productData[handle]) {
        productJson(handle).then(function (p) {
          if (!el.isConnected) return;
          var c2 = jsonCompare(p, item);
          if (c2) { try { paintCartLine(el, item, c2); } catch (e) { console.warn('[creatorcode] wagenregel', e); } }
        });
      }
    });
  }

  // Waakhond: ontbreekt onze prijsregel op een wagenregel terwijl er wel getekend zou moeten
  // worden, of kent de wagen die het script onthield een regel niet (verouderd), dan zelf
  // herstellen. Goedkoop (alleen DOM-lookups) en vangt elk pad dat we niet zagen aankomen.
  function cartWatchdog() {
    var els = cartLineElements();
    if (!els.length || !state.lastCart) { renderDebug(); return; }
    var items = state.lastCart.items || [];
    var stale = false, missing = false;
    Array.prototype.forEach.call(els, function (el) {
      var it = findCartItem(el, items);
      if (!it) { stale = true; return; }
      if (!el.querySelector('.cc-cart-price') && (allowed() || domCompare(el, it))) missing = true;
    });
    if (stale) { dlog('waakhond: regel onbekend, wagen opnieuw ophalen'); fetchCart().then(ingestCart).catch(function () {}); return; }
    if (missing) { dlog('waakhond: prijsregel ontbrak, opnieuw getekend'); render(); }
    healDrawerKeys();
    renderDebug();
  }

  // Diagnosepaneel (alleen met ?cc_debug=1 in de URL; uit met ?cc_debug=0): laat zien wat het
  // script weet, zodat een probleem in een andere browser zonder console te lezen is.
  function renderDebug() {
    if (!debugOn()) return;
    var box = document.getElementById('cc-debug');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'cc-debug';
      box.className = 'cc-debug';
      box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;max-width:min(96vw,560px);max-height:45vh;overflow:auto;margin:0;padding:8px 10px;font:11px/1.35 Menlo,monospace;color:#fff;background:rgba(0,0,0,.85);border-radius:8px;white-space:pre-wrap;pointer-events:auto;';
      document.body.appendChild(box);
    }
    var c = state.lastCart || {};
    var lines = [];
    lines.push('cc ' + VERSION + ' | ' + (navigator.userAgent.match(/(Safari|Chrome|Firefox|Edg)[^ ]*/g) || []).join(' ') + ' | ' + location.pathname);
    lines.push('code=' + state.code + ' allowed=' + allowed() + ' wepeak=' + JSON.stringify(state.wepeak) + ' blocked=' + state.blocked + ' orderLevel=' + state.orderLevel + ' pct=' + state.pct);
    lines.push('lastCart: ' + (c.items ? c.items.length : '-') + ' regels, total_discount=' + c.total_discount + ', codes=' + JSON.stringify(c.discount_codes || null) + ', renders=' + renderCartCount);
    (c.items || []).forEach(function (it) { lines.push('  cart ' + String(it.variant_id) + ' x' + it.quantity + ' key=' + it.key.slice(-8) + ' ' + it.original_price + '/' + it.final_price); });
    Array.prototype.forEach.call(cartLineElements(), function (el) {
      var row = el.querySelector('.cc-cart-price');
      var price = el.querySelector('.price');
      lines.push('  dom  ' + (el.getAttribute('data-variant-id') || '?') + ' x' + (el.getAttribute('data-quantity') || '?') + ' id=' + el.id.slice(-8) + ' rij=' + (row ? 'JA' : 'NEE') + ' price=' + (price ? price.textContent.replace(/\s+/g, ' ').trim().slice(0, 30) : '-'));
    });
    lines.push('--- log');
    lines = lines.concat(LOG.slice(-14));
    box.textContent = lines.join('\n');
  }

  /* ---------- prijs in de "In winkelwagen"-knop ----------
     Het thema zet daar de gewone variantprijs (<product-buy-price data-price>). Geldt de code
     voor deze variant, dan tonen we daar dezelfde nieuwe prijs als in de prijsregel; anders
     herstellen we de prijs van het thema. */

  function renderBuyButtons() {
    var btns = document.querySelectorAll('product-buy-price[form]');
    Array.prototype.forEach.call(btns, function (btn) {
      var formId = btn.getAttribute('form') || '';
      var priceEl = null;
      var m = formId.match(/^ProductForm-(.+)$/);
      if (m) {
        var box = document.getElementById('Price-' + m[1]);
        priceEl = box ? box.querySelector('.price[data-cc-variant]') : null;
      }
      var final = priceEl ? priceEl.getAttribute('data-cc-final') : null;
      var base = btn.getAttribute('data-price');
      var target = final ? final : base;
      if (!target || btn.getAttribute('data-cc-buy') === target) return;
      if (!final && !btn.hasAttribute('data-cc-buy')) return;     // nooit door ons aangeraakt: laten staan
      btn.setAttribute('data-cc-buy', target);
      btn.classList.toggle('cc-buy-active', !!final);
      btn.innerHTML = money(parseInt(target, 10));
    });
  }

  /* ---------- kortingsveld boven het subtotaal (drawer + winkelwagenpagina) ----------
     Altijd zichtbaar: geen klik op "Korting" meer nodig. Toepassen/verwijderen gaat via
     dezelfde weg als het thema (cart/update + sectie opnieuw renderen), zodat totalen
     meteen kloppen. */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function discountHosts() {
    var out = [];
    var drawer = document.querySelector('cart-drawer .drawer__footer-bottom > div');
    if (drawer) out.push({ host: drawer, before: drawer.firstElementChild, form: document.querySelector('cart-drawer form[is="cart-discount"]') });
    var totals = document.querySelector('.cart__sidebar .totals');
    if (totals && totals.parentNode) {
      var before = totals.previousElementSibling && totals.previousElementSibling.classList.contains('discounts') ? totals.previousElementSibling : totals;
      out.push({ host: totals.parentNode, before: before, form: document.querySelector('form[is="cart-discount"]') });
    }
    return out;
  }

  function codeAmounts(cart) {
    var amounts = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code') amounts[normalize(d.title)] = (amounts[normalize(d.title)] || 0) + (d.total_allocated_amount || 0);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (app.type === 'discount_code') amounts[normalize(app.title)] = (amounts[normalize(app.title)] || 0) + (a.amount || 0);
      });
    });
    return amounts;
  }

  var dboxBusy = false;
  var dboxNotice = null;   // { text, ok } melding die na het opnieuw renderen getoond moet worden

  function postDiscounts(codes, sectionId) {
    var body = { discount: codes.join(',') };
    if (sectionId) body.sections = [sectionId];
    var url = (window.theme && theme.routes && theme.routes.cart_update_url) || '/cart/update.js';
    var cfgFetch = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig('json') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    return fetch(url, Object.assign({}, cfgFetch, { body: JSON.stringify(body) })).then(function (r) { return r.json(); });
  }

  // Sets (producttype Bundel): kortingscodes gelden daar bewust niet (16-10-2026). Zit er alleen een set
  // in de wagen, dan zeggen we dat duidelijk in plaats van "kan niet worden toegepast".
  function cartHasSet(cart) { return ((cart && cart.items) || []).some(function (i) { return i.product_type === 'Bundel'; }); }
  function cartHasSingle(cart) { return ((cart && cart.items) || []).some(function (i) { return i.product_type !== 'Bundel'; }); }
  // Laatst geprobeerde code op een wagen met alleen sets: melding blijft staan, ook na herladen van /cart.
  // Tot 16-10-2026 12:00 (NL) geen "niet toepasbaar op bundels"-meldingen: VIP15 belooft tot dan korting op alles.
  var SET_NOTICES_FROM = Date.UTC(2026, 9, 16, 10, 0, 0);
  function setNoticesOn() { return Date.now() >= SET_NOTICES_FROM; }
  var lastSetTry = (function () { try { return sessionStorage.getItem('cc:settry2'); } catch (e) { return null; } })();
  function rememberSetTry(code) {
    lastSetTry = code || null;
    try { if (lastSetTry) sessionStorage.setItem('cc:settry2', lastSetTry); else sessionStorage.removeItem('cc:settry2'); } catch (e) {}
  }
  // Werkt de code wél in de wagen (bv. Wepeak-influencercodes, die ook op sets gelden), dan nooit een setmelding.
  function codeWorks(cart, code) {
    var c = normalize(code);
    return ((cart && cart.discount_codes) || []).some(function (d) { return d && normalize(d.code) === c && d.applicable !== false; });
  }
  function setOnlyNotice(cart, code) {
    if (!setNoticesOn()) return null;
    if (!cartHasSet(cart) || cartHasSingle(cart)) return null;
    if (codeWorks(cart, code)) return null;
    var c = String(code || '').toUpperCase();
    return cfg.locale === 'en'
      ? 'This discount code can\u2019t be applied to sets.'
      : 'Deze kortingscode kan niet worden toegepast op sets.';
  }
  // Code werkt (op losse items) en er zit ook een set in de wagen: ook dan melden dat de set niet meedoet.
  function setMixedNotice(cart, code) {
    if (!setNoticesOn()) return null;
    if (!cartHasSet(cart) || !cartHasSingle(cart)) return null;
    // Codes die óók op sets gelden (bv. VIP15): de set heeft dan zelf korting gekregen, geen melding.
    var setsDiscounted = (cart.items || []).some(function (i) {
      return i.product_type === 'Bundel' && (i.line_level_discount_allocations || []).some(function (a) { return a && a.amount > 0; });
    });
    if (setsDiscounted) return null;
    var c = String(code || '').toUpperCase();
    return cfg.locale === 'en'
      ? 'This discount code (' + c + ') cannot be combined with sets: it only applies to your single items.'
      : 'Deze kortingscode (' + c + ') is niet te combineren met sets: de korting geldt alleen voor je losse items.';
  }

  function updateDiscounts(codes, box, form) {
    if (dboxBusy) return Promise.resolve();
    dboxBusy = true;
    box.classList.add('is-busy');
    var sectionId = form ? form.getAttribute('data-section-id') : null;
    var strings = cfg.strings || {};
    return postDiscounts(codes, sectionId)
      .then(function (cart) {
        var bad = codes.filter(function (c) {
          return (cart.discount_codes || []).some(function (d) { return normalize(d.code) === normalize(c) && d.applicable === false; });
        });
        if (!bad.length) return cart;
        // Ongeldige code: melding klaarzetten en de code weer uit de wagen halen.
        dboxNotice = { text: strings.errorLabel || (window.theme && theme.discountStrings && theme.discountStrings.error) || 'Kortingscode kan niet worden toegepast', ok: false };
        var keep = codes.filter(function (c) { return bad.map(normalize).indexOf(normalize(c)) === -1; });
        return postDiscounts(keep, sectionId);
      })
      .then(function (cart) {
        if (window.theme && theme.pubsub) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: cart });
        }
        ingestCart(cart);
      })
      .catch(function (err) { console.warn('[creatorcode] kortingscode', err); })
      .then(function () { dboxBusy = false; box.classList.remove('is-busy'); });
  }

  // Code toepassen. Staat er (via een link) al een andere code, dan wint de nieuwe; werkt de
  // nieuwe code niet, dan blijft de oude staan en komt alleen dan de foutmelding.
  function applyDiscount(newCode, previous, box, form) {
    if (dboxBusy) return Promise.resolve();
    dboxBusy = true;
    box.classList.add('is-busy');
    var sectionId = form ? form.getAttribute('data-section-id') : null;
    var strings = cfg.strings || {};
    return postDiscounts([newCode], sectionId)
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return normalize(d.code) === newCode && d.applicable !== false; });
        if (ok) { rememberSetTry(null); return cart; }
        if (setOnlyNotice(cart, newCode)) rememberSetTry(newCode);
        dboxNotice = { text: setOnlyNotice(cart, newCode) || strings.errorLabel || (window.theme && theme.discountStrings && theme.discountStrings.error) || 'Kortingscode kan niet worden toegepast', ok: false };
        return postDiscounts(previous, sectionId);
      })
      .then(function (cart) {
        if (window.theme && theme.pubsub) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: cart });
        }
        ingestCart(cart);
      })
      .catch(function (err) { console.warn('[creatorcode] kortingscode', err); })
      .then(function () { dboxBusy = false; box.classList.remove('is-busy'); });
  }

  // Eén witte balk met altijd dezelfde knop. Een toegepaste code komt als klein label
  // (tag-icoon, code, kruisje) ín de balk te staan, met daarnaast het bedrag in het groen en
  // een leeg invoerveld voor een eventuele nieuwe code (die vervangt dan de oude: laatste wint).
  var TAG_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.5" fill="currentColor" stroke="none"/></svg>';

  function renderDiscountBox() {
    var cart = state.lastCart;
    if (!cart) return;
    var strings = cfg.strings || {};
    var label = strings.discountLabel || 'Kortingscode';
    var amounts = codeAmounts(cart);
    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.code && d.applicable !== false; }).map(function (d) { return normalize(d.code); });
    var amount = codes.reduce(function (sum, c) { return sum + (amounts[c] || 0); }, 0);
    var shown = codes.join(', ');
    var sig = shown + ':' + amount;

    discountHosts().forEach(function (h) {
      var box = h.host.querySelector(':scope > .cc-dbox');
      if (!box) {
        box = document.createElement('div');
        box.className = 'cc-dbox';
        box.innerHTML =
          '<form class="cc-dbox__form" novalidate>' +
            '<div class="cc-dbox__box">' +
              '<span class="cc-dbox__chip" hidden>' + TAG_ICON + '<span class="cc-dbox__chip-code"></span>' +
                '<button class="cc-dbox__remove" type="button">&times;</button>' +
              '</span>' +
              '<span class="cc-dbox__amount"></span>' +
              '<input class="cc-dbox__input" type="text" name="cc-discount" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' + esc(strings.placeholderLabel || label) + '" aria-label="' + esc(label) + '">' +
            '</div>' +
            '<button class="cc-dbox__apply" type="submit">' + esc(strings.applyLabel || 'Toepassen') + '</button>' +
          '</form>' +
          '<p class="cc-dbox__error" role="alert" hidden></p>';
        h.host.insertBefore(box, h.before || null);
        h.host.classList.add('cc-has-dbox');

        var input = box.querySelector('.cc-dbox__input');
        var error = box.querySelector('.cc-dbox__error');
        var form = box.querySelector('.cc-dbox__form');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = normalize(input.value);
          if (!value) { input.focus(); return; }
          error.hidden = true;
          var current = ((state.lastCart && state.lastCart.discount_codes) || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
          if (current.map(normalize).indexOf(value) !== -1) { input.value = ''; return; }
          applyDiscount(value, current, box, h.form);
        });
        // Enter zelf afhandelen: het thema onderschept de standaard formulierverzending in de drawer.
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
        });
        input.addEventListener('input', function () { error.hidden = true; });
        box.querySelector('.cc-dbox__remove').addEventListener('click', function (e) {
          e.preventDefault();
          error.hidden = true;
          updateDiscounts([], box, h.form);
        });
      }
      var errEl = box.querySelector('.cc-dbox__error');
      if (dboxNotice) {
        errEl.textContent = dboxNotice.text;
        errEl.hidden = false;
        errEl.removeAttribute('data-cc-setnote');
      } else {
        var waiting = (cart.discount_codes || []).filter(function (d) { return d && d.code && d.applicable === false; })[0];
        var tried = waiting ? waiting.code : lastSetTry;
        // Geen automatische meldingen (Dani 16-10 ±13:45): alleen een code die de klant zelf invoerde
        // (lastSetTry, gezet in applyDiscount) blijft na het opnieuw tekenen staan.
        var anyWorks = (cart.discount_codes || []).some(function (d) { return d && d.applicable !== false; });
        var setText = lastSetTry && !anyWorks ? setOnlyNotice(cart, lastSetTry) : null;
        if (!setText && lastSetTry) rememberSetTry(null);
        if (setText) {
          if (errEl.textContent !== setText) errEl.textContent = setText;
          errEl.hidden = false;
          errEl.setAttribute('data-cc-setnote', '');
        } else if (errEl.hasAttribute('data-cc-setnote')) {
          errEl.hidden = true;
          errEl.textContent = '';
          errEl.removeAttribute('data-cc-setnote');
        }
      }
      if (box.getAttribute('data-cc-sig') === sig) return;
      box.setAttribute('data-cc-sig', sig);
      var filled = codes.length > 0;
      var inp = box.querySelector('.cc-dbox__input');
      var chip = box.querySelector('.cc-dbox__chip');
      var remove = box.querySelector('.cc-dbox__remove');
      box.classList.toggle('cc-dbox--filled', filled);
      chip.hidden = !filled;
      chip.querySelector('.cc-dbox__chip-code').textContent = shown;
      box.querySelector('.cc-dbox__amount').innerHTML = amount > 0 ? '-' + money(amount) : '';
      inp.value = '';
      // Met een code erin blijft het veld naast het label leeg (het kruisje maakt duidelijk hoe je wisselt).
      inp.placeholder = filled ? '' : (strings.placeholderLabel || label);
      if (filled) {
        var removeLabel = fill((strings.removeLabel || 'Kortingscode {code} verwijderen').replace('%CODE%', '{code}'), { code: shown });
        remove.setAttribute('aria-label', removeLabel);
        remove.setAttribute('title', removeLabel);
      }
    });
    dboxNotice = null;
  }

  // Betaalmethoden (iDEAL, Apple Pay, Klarna, ...) onder de afrekenknop in de drawer.
  // De iconen komen uit een <template> in de snippet (shop.enabled_payment_types).
  function renderPaymentIcons() {
    var tpl = document.getElementById('cc-payment-icons');
    var buttons = document.querySelector('cart-drawer .drawer__footer-buttons');
    if (!tpl || !buttons || !tpl.content) return;
    var next = buttons.nextElementSibling;
    if (next && next.classList.contains('cc-payicons')) return;
    buttons.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), buttons.nextSibling);
  }

  // Aanbevelingskaart in de drawer ("Misschien vind je dit ook leuk"): knoptekst
  // "In winkelwagen · €44,95" volgt de codeprijs, net als bij de bundel.
  function renderRecButtons() {
    var cards = document.querySelectorAll('cart-rec-card');
    Array.prototype.forEach.call(cards, function (card) {
      var priceEl = card.querySelector('.cart-rec-card__price[data-cc-variant]');
      var txt = card.querySelector('[data-cart-rec-add-text]');
      if (!priceEl || !txt || txt.textContent.indexOf('·') === -1) return;
      var fin = priceEl.getAttribute('data-cc-final');
      if (!fin) return;
      var parts = txt.textContent.split('·');
      var want = parts[0] + '· ' + money(parseInt(fin, 10)).replace(/<[^>]+>/g, '');
      if (txt.textContent !== want) txt.textContent = want;
    });
  }

  // Alleen deze codes gelden ook op sets (producttype Bundel). Elke andere klaarstaande code (flow-, influencer-,
  // nieuwsbriefcode) krijgt bij de bundels een rode waarschuwing (Dani 16-10-2026: harde eis).
  var BUNDLE_CODES = ['VIP15'];
  // Rode waarschuwing op de bundelpagina is verwijderd (Dani 16-10 ±10:05): VIP15 werkt op bundels, dus
  // nergens "niet toepasbaar" tonen. Functie blijft als lege haak.
  function renderBundleWarn() {}

  function render() {
    renderBundleWarn();
    priceElements().forEach(renderOne);
    renderRecButtons();
    Array.prototype.forEach.call(bundlePriceElements(), renderOne);   // zelfde opbouw als de productkaart
    renderBundleTotals();
    renderBuyButtons();
    renderCart();
    polishDiscountLists();
    renderDiscountBox();
    renderPaymentIcons();
    renderDebug();
  }

  /* ---------- kortingsregel boven het subtotaal (lijst van het thema) ----------
     Het thema toont daar "[icoon] CODE  [-€4,49]" met een grote zwarte badge. We zetten de
     codenaam in een klein label ("Kortingscode  KEVIN10") zodat de CSS het rustiger kan tonen. */

  function polishDiscountLists() {
    var ps = document.querySelectorAll('.drawer__footer-bottom .discounts__discount > p, .cart__sidebar .discounts__discount > p');
    Array.prototype.forEach.call(ps, function (p) {
      if (p.getAttribute('data-cc-polished')) return;
      var nodes = Array.prototype.filter.call(p.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (!nodes.length) return;
      var code = nodes.map(function (n) { return n.textContent.trim(); }).join(' ');
      nodes.forEach(function (n) { p.removeChild(n); });
      var label = document.createElement('span');
      label.className = 'cc-dl-label';
      label.textContent = cfg.strings.discountLabel || 'Kortingscode';
      var pill = document.createElement('span');
      pill.className = 'cc-dl-code';
      pill.textContent = code;
      p.appendChild(label);
      p.appendChild(pill);
      p.setAttribute('data-cc-polished', '1');
      if (p.parentNode) p.parentNode.classList.add('cc-dl');
    });
  }

  /* ---------- reparatie: carrousel "Misschien vind je dit ook leuk" in de cart drawer ----------
     Het thema bouwt die Flickity-carrousel op terwijl de drawer nog dicht is; de hoogte blijft
     dan 0 en de kaarten zijn onzichtbaar. Zodra de viewport lager is dan een kaart, laten we
     Flickity opnieuw meten. Staat los van de kortingscode en werkt ook zonder actieve code. */

  // Kloppen de maten die Flickity van de kaarten onthouden heeft nog met de echte maten?
  // (De drawer is dicht bij het opbouwen: dan meet Flickity 0 x 0 en staan alle kaarten op
  // dezelfde plek. Wie dan swipet, ziet de carrousel verspringen.)
  function carouselStale(slider) {
    if (!slider || !slider.cells) return false;
    for (var i = 0; i < slider.cells.length; i++) {
      var c = slider.cells[i];
      if (!c.element || !c.size) continue;
      if (Math.abs(c.size.width - c.element.offsetWidth) > 1) return true;
      if (Math.abs(c.size.height - c.element.offsetHeight) > 1) return true;
    }
    return false;
  }

  function fixCartCarousels() {
    var els = document.querySelectorAll('[id^="MiniCart-"] product-complementary.flickity-enabled');
    Array.prototype.forEach.call(els, function (el) {
      enhanceCarousel(el);
      var vp = el.querySelector('.flickity-viewport');
      var cell = el.querySelector('.horizontal-product');
      if (!vp || !cell) return;
      var vh = vp.getBoundingClientRect().height;
      var ch = cell.getBoundingClientRect().height;
      var slider = carouselSlider(el);
      if (!slider || typeof slider.resize !== 'function') return;
      if ((ch > 0 && vh + 2 < ch) || carouselStale(slider)) {
        try { slider.resize(); } catch (e) { /* negeren */ }
      }
    });
  }

  function carouselSlider(el) {
    return (el.carousel && el.carousel.slider) || (window.Flickity && window.Flickity.data(el)) || null;
  }

  // Extra's op de carrousel: horizontaal scrollen met muis/trackpad (Magic Mouse) zet de
  // carrousel een kaart verder of terug, en de rand-vervaging gaat uit bij de laatste kaart.
  function enhanceCarousel(el) {
    if (el.getAttribute('data-cc-enhanced')) return;
    var slider = carouselSlider(el);
    if (!slider) return;
    el.setAttribute('data-cc-enhanced', '1');

    var updateEdges = function () {
      var last = slider.slides ? slider.slides.length - 1 : 0;
      el.classList.toggle('cc-at-end', slider.selectedIndex >= last);
      el.classList.toggle('cc-at-start', slider.selectedIndex <= 0);
    };
    try { slider.on('select', updateEdges); } catch (e) { /* negeren */ }
    updateEdges();
    // Vlak voor een swipe/klik en bij elke kaartwissel: eerst zeker weten dat de maten kloppen.
    try {
      slider.on('pointerDown', function () { if (carouselStale(slider)) slider.resize(); });
      slider.on('select', function () { if (carouselStale(slider)) slider.resize(); });
    } catch (e) { /* negeren */ }

    var lastStep = 0, acc = 0;
    el.addEventListener('wheel', function (e) {
      var dx = e.deltaX, dy = e.deltaY;
      if (Math.abs(dx) <= Math.abs(dy)) return;            // verticaal: gewoon de drawer scrollen
      e.preventDefault();
      acc += dx;
      var now = Date.now();
      if (now - lastStep < 500 || Math.abs(acc) < 12) return;
      lastStep = now;
      acc = 0;
      try { if (dx > 0) slider.next(); else slider.previous(); } catch (err) { /* negeren */ }
    }, { passive: false });
  }

  var carouselTimers = [];
  function scheduleCarouselFix() {
    carouselTimers.forEach(clearTimeout);
    carouselTimers = [60, 350, 900, 2000].map(function (t) { return setTimeout(fixCartCarousels, t); });
  }


  /* ---------- Engelse tekst-map (/en) ----------
   * Een paar teksten komen uit themacode of uit optiewaardes die Shopify niet via
   * vertalingen laat aanpassen (bezorgbelofte met dagnaam, Klarna-regel, kleurnamen,
   * Trustpilot-regel). Op een niet-Nederlandse taal worden die hier client-side
   * vervangen. Alleen korte tekstknopen, alleen exacte woorden/patronen.
   */
  var EN_WORDS = {
    'Zwart': 'Black', 'Wit': 'White', 'Grijs': 'Grey', 'Roze': 'Pink', 'Rood': 'Red', 'Blauw': 'Blue',
    'Groen': 'Green', 'Olijf': 'Olive', 'Bordeaux Rood': 'Burgundy Red', 'Midnight Blauw': 'Midnight Blue',
    'Pine Groen': 'Pine Green', 'Beige': 'Beige', 'Bruin': 'Brown', 'Paars': 'Purple', 'Geel': 'Yellow',
    'Oranje': 'Orange', 'Lichtblauw': 'Light Blue', 'Donkerblauw': 'Dark Blue', 'Maattabel': 'Size chart',
    'Kleur': 'Colour', 'Maat': 'Size', 'Selecteer maat': 'Select size', 'Selecteer een maat': 'Select a size',
    // Kopjes van de maattabel (metavelden custom.maattabel_cm / _inches)
    'Taille': 'Waist', 'Heupen': 'Hips', 'Borst': 'Bust'
  };
  var EN_DAYS = { zo: 'Sun', ma: 'Mon', di: 'Tue', wo: 'Wed', do: 'Thu', vr: 'Fri', za: 'Sat' };
  var EN_MONTHS = { jan: 'Jan', feb: 'Feb', mrt: 'Mar', apr: 'Apr', mei: 'May', jun: 'Jun', jul: 'Jul', aug: 'Aug', sep: 'Sep', okt: 'Oct', nov: 'Nov', dec: 'Dec' };
  var EN_WORD_RE = new RegExp('(^|[^A-Za-zÀ-ɏ])(' + Object.keys(EN_WORDS).sort(function (a, b) { return b.length - a.length; }).map(function (k) {
    return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }).join('|') + ')(?![A-Za-zÀ-ɏ])', 'g');
  var EN_PATTERNS = [
    [/^Besteld voor (\d{1,2}:\d{2}), (zo|ma|di|wo|do|vr|za)\. (\d{1,2}) (jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec) in huis$/, function (m) {
      return 'Order before ' + m[1] + ', delivered ' + EN_DAYS[m[2]] + ' ' + m[3] + ' ' + EN_MONTHS[m[4]];
    }],
    [/^Betaal in 3 delen van (.+?) \(zonder rente\) met Klarna$/, function (m) { return 'Pay in 3 instalments of ' + m[1] + ' (interest-free) with Klarna'; }],
    [/^Levering rond\b/, function () { return 'Delivery around'; }],
    [/^(\d[,.]\d) uit (\d+) reviews op Trustpilot$/, function (m) { return m[1].replace(',', '.') + ' out of ' + m[2] + ' reviews on Trustpilot'; }],
    // Dezelfde regels, maar dan in losse tekstknopen (het thema zet de datum en het bedrag in een eigen <span>).
    [/^Besteld voor (\d{1,2}:\d{2}),\s*$/, function (m) { return 'Order before ' + m[1] + ', delivered '; }],
    [/^(zo|ma|di|wo|do|vr|za)\. (\d{1,2}) (jan|feb|mrt|apr|mei|jun|jul|aug|sep|okt|nov|dec)$/, function (m) { return EN_DAYS[m[1]] + ' ' + m[2] + ' ' + EN_MONTHS[m[3]]; }],
    [/^in huis$/, function () { return ''; }],
    [/^Betaal in 3 delen van$/, function () { return 'Pay in 3 instalments of'; }],
    [/^\(zonder rente\) met Klarna$/, function () { return '(interest-free) with Klarna'; }],
    [/^Voor 23:59 besteld, morgen in huis$/, function () { return 'Order before 23:59, delivered tomorrow'; }],
    [/^Je bespaart (.+)$/, function (m) { return 'You save ' + m[1]; }],
    [/^Je bespaart$/, function () { return 'You save'; }],
    [/^Kies een maat$/, function () { return 'Choose a size'; }],
    [/^Eén maat$/, function () { return 'One size'; }],
    [/^Er ging iets mis\. Probeer het opnieuw\.$/, function () { return 'Something went wrong. Please try again.'; }],
    [/^Gratis verzending vanaf €\s?75,?-?$/, function () { return 'Free shipping from €75'; }],
    [/^Extra korting met code (.+)$/, function (m) { return 'Extra discount with code ' + m[1]; }],
    [/^Kortingscode (.+) is toegepast$/, function (m) { return 'Discount code ' + m[1] + ' has been applied'; }],
    [/^Vanaf(?=\s|$)/, function () { return 'From'; }]
  ];
  var enSeen = (typeof WeakMap === 'function') ? new WeakMap() : null;

  function enTranslateText(t) {
    var s = t.trim();
    if (!s || s.length > 140) return null;
    for (var i = 0; i < EN_PATTERNS.length; i++) {
      var m = s.match(EN_PATTERNS[i][0]);
      if (m) return t.replace(s, EN_PATTERNS[i][1](m));
    }
    if (!/[A-Z]/.test(s)) return null;
    var out = t.replace(EN_WORD_RE, function (all, pre, w) { return pre + EN_WORDS[w]; });
    return out === t ? null : out;
  }

  function enTextMap(root) {
    if (!cfg.locale || cfg.locale === 'nl' || !document.body) return;
    root = root || document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || !n.nodeValue || n.nodeValue.length > 160) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'NOSCRIPT' || tag === 'CODE' || tag === 'PRE') return NodeFilter.FILTER_REJECT;
        if (p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (enSeen && enSeen.get(n) === n.nodeValue) continue;
      var t = enTranslateText(n.nodeValue);
      if (t !== null) n.nodeValue = t;
      if (enSeen) enSeen.set(n, n.nodeValue);
    }
    // Ook titels/aria van swatches en selects
    var attrs = root.querySelectorAll ? root.querySelectorAll('[title], [aria-label], option, [data-value]') : [];
    for (var j = 0; j < attrs.length; j++) {
      var el = attrs[j];
      ['title', 'aria-label'].forEach(function (a) {
        var v = el.getAttribute(a); if (!v) return;
        var tv = enTranslateText(v); if (tv !== null) el.setAttribute(a, tv);
      });
    }
  }
  var enTimer = null;
  function scheduleEnTextMap() {
    if (!cfg.locale || cfg.locale === 'nl') return;
    clearTimeout(enTimer);
    enTimer = setTimeout(function () { enTextMap(); }, 40);
  }

  /* ---------- Alia-vangnet ----------
     Alia maakt na een claim een eenmalige Shopify-code aan, maar past die alleen toe als de
     popup zo is ingesteld (auto-apply of "Apply my discount"-klik). Anders krijgt de klant
     alleen de code te zien en gebeurt er op de site niets. Alia bewaart zijn sessie-token en
     flow in localStorage en haalt zelf de geclaimde beloningen op bij zijn backend; datzelfde
     doen wij hier (zelfde headers), en een nog niet toegepaste code passen we dan zelf toe. */

  var aliaTried = 0;
  function aliaClaimedCode() {
    var jwt = null, actions = [];
    try { jwt = localStorage.getItem('alia-jwt'); actions = JSON.parse(localStorage.getItem('alia-user-actions') || '[]'); } catch (e) { return Promise.resolve(null); }
    if (!jwt || !actions.length) return Promise.resolve(null);
    var flow = null;
    for (var i = actions.length - 1; i >= 0; i--) { if (actions[i] && actions[i].flowID) { flow = actions[i].flowID; break; } }
    var shop = (window.Shopify && Shopify.shop) || '';
    if (!flow || !shop) return Promise.resolve(null);
    var url = 'https://backend.alia-prod.com/user/claimed-rewards/all?shop=' + encodeURIComponent(shop);
    return fetch(url, { headers: { 'x-alia-jwt': jwt, 'x-alia-flow-id': String(flow), 'x-alia-page-url': location.href, Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (list) {
        if (!list || !list.length) return null;
        var now = Date.now(), best = null;
        list.forEach(function (rw) {
          if (!rw || !rw.shopifyCode) return;
          if (rw.expiresAt && new Date(rw.expiresAt).getTime() < now) return;
          best = rw;   // laatste (nieuwste) wint
        });
        return best ? normalize(best.shopifyCode) : null;
      })
      .catch(function () { return null; });
  }

  function aliaFallback(reason) {
    if (state.code || readCookie(COOKIE_NAME)) return;         // er is al een code
    if (state.lastCart && (state.lastCart.discount_codes || []).length) return;
    var done = null;
    try { done = sessionStorage.getItem('cc:alia-applied'); } catch (e) { /* negeren */ }
    aliaTried += 1;
    aliaClaimedCode().then(function (code) {
      if (!code || code === done || ignored(code) || state.code) return;
      dlog('Alia-beloning gevonden (' + reason + '): ' + code + ', zelf toepassen');
      try { sessionStorage.setItem('cc:alia-applied', code); sessionStorage.setItem('cc:cookie-applied', code); } catch (e) { /* negeren */ }
      // Zelfde weg als Alia (zet de Shopify-kortingscookie) en daarna meteen in de wagen.
      fetch('/discount/' + encodeURIComponent(code)).catch(function () {}).then(function () {
        return applyCodeToCart(code).then(ingestCart);
      }).catch(function (e) { dlog('Alia-code toepassen mislukt: ' + (e && e.message)); });
    });
  }

  /* ---------- start ---------- */

  function init() {
    var params = new URLSearchParams(location.search);
    // Wepeak-link (?wepeak=CODE) of ?discount=CODE: code in de wagen zetten. Het getal in
    // wp_discount wordt bewust genegeerd; het percentage komt van het Wepeak-adres.
    var urlCode = normalize(params.get('wepeak') || params.get('discount'));
    var start;
    if (urlCode) {
      start = applyCodeToCart(urlCode);
    } else {
      start = fetchCart().then(function (cart) {
        // Cookie van een Shopify-kortingslink alleen gebruiken als de wagen nog geen code
        // kent, en maar één keer per sessie (anders komt een verwijderde code steeds terug).
        var codes = cart.discount_codes || [];
        var hasCodes = codes.length > 0;
        var cookie = normalize(readCookie(COOKIE_NAME));
        var applied = null;
        try { applied = sessionStorage.getItem('cc:cookie-applied'); } catch (e) { /* negeren */ }
        dlog('init: wagen ' + (cart.item_count || 0) + ' stuks, codes=' + JSON.stringify(codes) + ', cookie=' + (cookie || '-') + ', al toegepast=' + (applied || '-'));
        // Kortingslink geklikt terwijl er al een andere code in de wagen zat: Shopify zet de linkcode
        // achteraan erbij en laat dan de "beste" winnen (bv. LIEKE15 op losse items). De laatst
        // geklikte link hoort te winnen: alleen de linkcode laten staan (Dani 16-10, VIP15-mail).
        var last = codes.length ? normalize(codes[codes.length - 1].code) : '';
        if (cookie && codes.length > 1 && last === cookie) {
          dlog('init: linkcode ' + cookie + ' wint van ' + JSON.stringify(codes.slice(0, -1).map(function (d) { return d.code; })));
          try { sessionStorage.setItem('cc:cookie-applied', cookie); } catch (e) { /* negeren */ }
          return applyCodeToCart(cookie);
        }
        if (cookie && applied !== cookie) {
          // Zat er al een andere code in de wagen, dan zet Shopify de linkcode erbij als
          // "niet toepasbaar" (codes combineren niet). Een nieuwe creatorlink hoort te winnen:
          // probeer de linkcode alleen; werkt die niet, dan de oude code(s) terugzetten.
          var blocked = hasCodes && codes.some(function (d) { return normalize(d.code) === cookie && d.applicable === false; });
          if (!hasCodes || blocked) {
            try { sessionStorage.setItem('cc:cookie-applied', cookie); } catch (e) { /* negeren */ }
            var previous = codes.filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
            return applyCodeToCart(cookie).then(function (c2) {
              var ok = !(c2.item_count > 0) || (c2.discount_codes || []).some(function (d) { return normalize(d.code) === cookie && d.applicable !== false; });
              return ok || !previous.length ? c2 : applyCodeToCart(previous.join(','));
            });
          }
        }
        return cart;
      });
    }
    start.then(ingestCart).catch(function (err) { console.warn('[creatorcode] winkelwagen niet leesbaar', err); });
    preloadPdpVariants();
    render();   // direct, o.a. om de bundel-totaalregel zonder keuze meteen te verbergen

    // Pop-ups zoals Alia zetten een code via een stille aanroep van /discount/CODE: dat vult de cookie
    // en de wagen, maar de pagina laadt niet opnieuw. Daarom de cookie in de gaten houden en meteen
    // doorrekenen zodra er een nieuwe code in staat (ook als de wagen nog leeg is).
    var lastCookie = normalize(readCookie(COOKIE_NAME));
    var checkCookie = function () {
      var c = normalize(readCookie(COOKIE_NAME));
      if (c === lastCookie) return;
      lastCookie = c;
      if (!c || ignored(c) || c === state.code) return;
      dlog('cookie discount_code gezien: ' + c + ', code in wagen zetten');
      try { sessionStorage.setItem('cc:cookie-applied', c); } catch (e) { /* negeren */ }
      applyCodeToCart(c).then(ingestCart).catch(function (e) { dlog('code in wagen zetten mislukt: ' + (e && e.message)); });
    };
    setInterval(checkCookie, 1000);
    document.addEventListener('visibilitychange', checkCookie);
    // Alia-vangnet: kort na het laden en na het sluiten van een Alia-popup kijken of er een
    // geclaimde code is die nog niet is toegepast.
    [2500, 8000, 20000, 45000, 90000].forEach(function (t) { setTimeout(function () { aliaFallback('timer'); }, t); });
    ['alia:popupClose', 'alia:popupView'].forEach(function (ev) {
      window.addEventListener(ev, function () { setTimeout(function () { aliaFallback(ev); }, 1500); setTimeout(function () { aliaFallback(ev); }, 6000); });
      document.addEventListener(ev, function () { setTimeout(function () { aliaFallback(ev); }, 1500); setTimeout(function () { aliaFallback(ev); }, 6000); });
    });
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/discount\//.test(url)) p.then(function () { setTimeout(checkCookie, 50); setTimeout(checkCookie, 700); }, function () {});
        return p;
      };
    }
    scheduleEnTextMap();
    document.addEventListener('variant:changed', scheduleEnTextMap);
    document.addEventListener('variantChanged', scheduleEnTextMap);

    // Alles wat het thema opnieuw rendert (filters, variantwissel, quick view, cart drawer) opnieuw bekijken.
    // Ook op verwijderde knopen letten: haalt het thema (of een app) bij het opnieuw renderen van
    // de drawer onze prijsregel weg zonder iets toe te voegen, dan tekenen we die meteen opnieuw.
    // Prijsblokken die een ander script zelf opnieuw opbouwt ("Vaak samen gekocht" bij kleur-
    // of maatwissel, de aanbevelingskaart in de drawer): onze prijsregel is dan even weg en het
    // blok krimpt. Die gevallen tekenen we direct in dezelfde stap, vóór de browser iets laat
    // zien, zodat niets knippert. De rest gaat via de korte wachttijd van scan().
    var IMMEDIATE = 'bundle-save, cart-rec-card, [data-card-price], .cart-rec-card__price, cart-drawer, cart-items, product-info, [id^="Price-"], [id^="BuyButtonPrice-"], [id^="StickyPrice-"]';
    // Eigen knopen (alles wat dit script zelf plaatst of weghaalt) tellen niet mee: anders zou
    // elke hertekening zichzelf opnieuw aanroepen.
    var isOwn = function (n) {
      if (!n || n.nodeType !== 1) return false;
      var c = n.className;
      return typeof c === 'string' && /(^|\s)cc-/.test(c);
    };
    var isOwnMutation = function (m) {
      var i;
      for (i = 0; i < m.addedNodes.length; i++) if (!isOwn(m.addedNodes[i])) return false;
      for (i = 0; i < m.removedNodes.length; i++) if (!isOwn(m.removedNodes[i])) return false;
      return true;
    };
    new MutationObserver(function (muts) {
      var immediate = false, any = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (isOwnMutation(m)) continue;
        if (m.target && m.target.nodeType === 1 && m.target.id === 'cc-debug') continue;
        var touched = false, j;
        for (j = 0; j < m.addedNodes.length && !touched; j++) if (!isOwn(m.addedNodes[j])) touched = true;
        for (j = 0; j < m.removedNodes.length && !touched; j++) {
          var n = m.removedNodes[j];
          if (n.nodeType === 1 && !isOwn(n) && n.querySelector && n.querySelector('.cc-cart-price, .cc-node, .cc-dbox')) touched = true;
        }
        if (!touched) continue;
        any = true;
        var t = m.target && m.target.nodeType === 1 ? m.target : (m.target && m.target.parentElement);
        if (t && t.closest && t.closest(IMMEDIATE)) immediate = true;
      }
      if (!any) return;
      if (immediate) scanNow();
      else scan();
      scheduleCarouselFix();
      scheduleEnTextMap();
    }).observe(document.body, { childList: true, subtree: true });

    // Drawer gaat open/dicht: carrousel opnieuw laten meten. Ook als afbeeldingen erin laden.
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () { scheduleCarouselFix(); setTimeout(refitCartLines, 50); setTimeout(refitCartLines, 400); }).observe(drawer, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden', 'hidden'] });
    }
    var refitTimer = null;
    window.addEventListener('resize', function () { clearTimeout(refitTimer); refitTimer = setTimeout(refitCartLines, 150); });
    setInterval(cartWatchdog, 1500);
    if (debugOn()) { dlog('start ' + VERSION); setTimeout(renderDebug, 500); }
    document.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('[id^="MiniCart-"]')) fixCartCarousels();
    }, true);
    scheduleCarouselFix();

    // Na het toevoegen van een product (bijv. een maat kiezen bij "Misschien vind je dit ook
    // leuk"): de drawer meteen bovenaan zetten, zodat de klant de lijst met producten ziet in
    // plaats van te blijven hangen bij de aanbevelingen. Een paar keer, omdat het thema de
    // drawer-inhoud vlak daarna nog opnieuw rendert.
    var scrollDrawerTop = function () {
      var el = document.querySelector('cart-drawer .drawer__scrollable');
      if (!el) return;
      var prev = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.scrollTop = 0;
      el.style.scrollBehavior = prev;
    };
    document.addEventListener('ajaxProduct:added', function () {
      [0, 150, 450, 900, 1500].forEach(function (t) { setTimeout(scrollDrawerTop, t); });
    });

    // Na elke wagenwijziging nog een paar keer natekenen: het thema en apps (Alia) renderen de
    // drawer soms later nog eens opnieuw, en tekenen is goedkoop en verandert niets als alles klopt.
    var lateRender = function () { [300, 1000, 2500].forEach(function (t) { setTimeout(render, t); }); };
    document.addEventListener('ajaxProduct:added', lateRender);

    // Winkelwagen-updates van het thema: de wagen die het thema meestuurt (antwoord van
    // cart/change, cart/add of cart/update) meteen gebruiken, zodat prijsregels, kortingsveld
    // en betaaliconen in dezelfde stap terugkomen als de nieuwe drawer-HTML (geen knipperen).
    // Daarna voor de zekerheid nog de echte wagen ophalen.
    if (window.theme && theme.pubsub) {
      var refresh = function (event) {
        var c = event && event.cart;
        dlog('cartUpdate van ' + (event && event.source) + (c && c.items ? ' (' + c.items.length + ' regels' + (c.discount_codes ? '' : ', geen discount_codes') + ')' : ''));
        if (c && c.items && c.discount_codes && !c.errors) { try { ingestCart(c); } catch (e) { /* negeren */ } }
        fetchCart().then(ingestCart).catch(function () {});
        lateRender();
      };
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, refresh);
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.discountUpdate, refresh);
    }
    document.addEventListener('shopify:cart:discount-update', function () {
      setTimeout(function () { fetchCart().then(ingestCart).catch(function () {}); }, 400);
    });
  }

  // Publieke API, o.a. voor een eigen link-systeem: CreatorCode.apply('ANNA15')
  window.CreatorCode = {
    apply: function (code) { return applyCodeToCart(normalize(code)).then(ingestCart); },
    clear: function () { return applyCodeToCart('').then(ingestCart); },
    refresh: function () { return fetchCart().then(ingestCart); },
    state: state
  };

  guardCartItems();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
